/**
 * Surveillance de l'état de la batterie (window.__batteryStatus), lue par
 * detectOptimalPixelRatio() dans hooks/useQualitySettings.js.
 *
 * ⚠️ Module volontairement SANS dépendance à three : il est importé par main.jsx,
 * donc chargé sur toutes les pages. L'importer depuis useQualitySettings.js tirait
 * Three.js (~250 Ko compressés) dans le bundle d'entrée, y compris sur la landing.
 */
export function initBatteryMonitoring() {
  if (!('getBattery' in navigator)) return;
  navigator.getBattery().then((battery) => {
    window.__batteryStatus = {
      charging: battery.charging,
      level: battery.level,
    };

    battery.addEventListener('chargingchange', () => {
      window.__batteryStatus.charging = battery.charging;
    });

    battery.addEventListener('levelchange', () => {
      window.__batteryStatus.level = battery.level;
    });
  }).catch(() => {
    // Battery API indisponible : pas bloquant
  });
}
